<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" :to="{name:'H040020'}" tag="span"></router-link>
      活动详情</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="banner"><img :src='info.I_ACTIVITY_DETAIL_IMG' /></div>
      <div class="activity_title">
        <span>{{info.I_TITLE}}</span>
      </div>
      <div class="activity_contents">
        <div class="item">
          <label class="item_title">【参与校区】</label>
          <p class="item_value">{{info.I_SCHOOL_NAME}}</p>
        </div>
        <div class="item">
          <label class="item_title">【活动时间】</label>
          <p class="item_value">{{info.I_DATE_TIME_DES}}</p>
        </div>
        <div class="item">
          <label class="item_title">【计划人数】</label>
          <p class="item_value">{{info.I_PERSON_NUM}}</p>
        </div>
        <div class="item">
          <label class="item_title">【活动费用】</label>
          <p class="item_value">{{info.I_AMT_DESC}}</p>
        </div>
        <div class="item introduction">
          <label class="item_title">【活动简介】</label>
          <div class="item_value">{{info.I_CONTENT}}</div>
          <a v-if="info.I_DETAIL_URL != null && info.I_DETAIL_URL != ''" :href="info.I_DETAIL_URL">活动详情</a>
        </div>
        <div class="item">
          <label class="item_title">【报名学员】</label>
          <div class="member">
            <label class="person_check" v-if="info.I_CHECKBOX_ENABLE_FLAG == 'Y'" v-for="person in info.dataList" :class="{active: person.I_CHECKED_FLAG=='Y'}" @click="clickPerson($event)">
              <span></span>{{person.I_STUDENT_NAME}}<span class="person_key" style="display: none;">{{person.I_KEY}}</span></label>
            <label class="person_check" v-if="info.I_CHECKBOX_ENABLE_FLAG == 'N'" v-for="person in info.dataList" :class="{active: person.I_CHECKED_FLAG=='Y'}">
              <span></span>{{person.I_STUDENT_NAME}}<span class="person_key" style="display: none;">{{person.I_KEY}}</span></label>
          </div>
        </div>
      </div>

      <button v-if="info.I_BUTTON_ENABLE_FLAG == 'N'" disabled class="bottom_btn notClick" @click="signUp">{{info.I_BUTTON_NAME}}</button>
      <button v-if="info.I_BUTTON_ENABLE_FLAG == 'Y'" class="bottom_btn" @click="signUp">{{info.I_BUTTON_NAME}}</button>
    </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        info: {
          dataList: []
        }
      }
    },
    created() {
      let id = this.$route.params.id
      if(id) {
        window.localStorage.setItem("H040030", id)
      } else {
        id = window.localStorage.getItem("H040030")
      }
      let param = {
        I_ACTIVITY_NO_SYS: id
      }
      DataRequestFactory.I040030(param).then((response) => {
      this.info = response
    })
    },
    methods: {
      signUp() {
        let checkboxs = $(".person_check.active")
        if(checkboxs.length == 0) {
          weui.topTips("至少选择一个学员");
          return false
        }
        let dataList = []
        for(let i=0; i< checkboxs.length; i++) {
          let obj = {I_KEY:checkboxs.eq(i).find(".person_key")[0].textContent}
          dataList.push(obj)
        }

        let params = {
          I_ACTIVITY_NO_SYS:this.info.I_ACTIVITY_NO_SYS,
          I_BUTTON_NAME: this.info.I_BUTTON_NAME,
          dataCount: checkboxs.length,
          dataList: dataList
        }
        DataRequestFactory.I040031(params).then((response) => {
          if(response.resultCode == "0") {
            weui.topTips("操作成功");
            this.$router.push({name: "H040020"})
          }
        })

      },
      clickPerson(e) {
        if($(e.currentTarget).hasClass("active")) {
          $(e.currentTarget).removeClass("active")
        } else {
          $(e.currentTarget).addClass("active")
        }
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 0
      $(".scroll_area").css("height", heightDiff + "px"   )


      $.each($("textarea"), function(i, n){
        $(n).css("height", n.scrollHeight + "px");
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H040030.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H040030.vue